// React
import React from "react";
import ComponentLoading from "common/ui/loading/ComponentLoading";
//-------------------------------------------------------------------------------------------------------------------------------
// Styles
//-------------------------------------------------------------------------------------------------------------------------------
import styles from "./LoadingWrapper.less";
//-------------------------------------------------------------------------------------------------------------------------------
// Component
//-------------------------------------------------------------------------------------------------------------------------------
export default class LoadingWrapper extends React.Component {
    render() {
        let { isFetching, isRelativeToContainer } = this.props;
        let styleToUse = "";
        if (isRelativeToContainer) {
            styleToUse = styles.container;
        }
        return (React.createElement("div", { className: styleToUse },
            isFetching && React.createElement(ComponentLoading, null),
            this.props.children));
    }
}
